<template lang="jade">
  div
    component(v-for="c in fdata.content"
              ":is"="c.type"
              ":fdata"="c")
</template>

<script>
export default {
  data () {
    return { uid: this.$parent.uid }
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// hide.vue?1c1f3cfe